// What a route's parameters may hold before they are put into an API path. Import-free so the
// unit tests can load it.
//
// A page's address is attacker-controllable and React Router hands the page its parameters
// *decoded*: `/pay/<uuid>%2Fconfirm%3F` arrives as "<uuid>/confirm?". Built into
// `/api/requests/${id}/status` unchecked, that is a request to a different endpoint, sent with
// the signed-in person's cookie. So a parameter is checked for its shape, then encoded anyway.

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** True for a request id as the app makes them. */
export function isUuid(value: string): boolean {
  return UUID.test(value);
}

const SLUG = /^[a-z0-9]+(?:-[a-z0-9]+)*$/i;

/** True for something that can be an organisation's public link (the server
 *  lowercases it, so case doesn't matter here). */
export function isSlugParam(value: string): boolean {
  return value.length >= 1 && value.length <= 64 && SLUG.test(value);
}
